import s from './index.module.css'
import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { setTheme } from '~local/actions'

import Header from './header'
import Dialog from '~co/overlay/dialog'

class ScreenBasic extends React.Component {

    render() {
        const { className='', children, theme, appSize, setTheme, rehydrated, ...etc } = this.props
        
        return (
            <>
                <Helmet defer={false}>
                    <html
                        data-theme={theme.auto ? 'auto' : theme.app}
                        data-app-size={appSize} />
                    
                    {theme.auto ? [
                        <meta key="light" name='theme-color' media='(prefers-color-scheme: light)' content='#FFFFFF' />,
                        <meta key="dark" name='theme-color' media='(prefers-color-scheme: dark)' content='#2A2B2D' />
                    ] : (
                        <meta name='theme-color' content={theme.app == 'night' ? '#2A2B2D' : '#FFFFFF'} />
                    )}
                </Helmet>

                <div 
                    {...etc}
                    data-is-page
                    className={s.page + ' ' + className}>
                    {children}

                    <Dialog />
                </div>
            </>
        )
    }
}

export default connect(
    (state, { appSize })=>({
        rehydrated: state._persist.rehydrated,
        theme: state.local.theme,
        appSize: appSize || state.local.appSize,
    }),
    {
        setTheme
    }
)(ScreenBasic)

export { Header }